import { Avatar, Box, Container, Divider, Heading, SimpleGrid, Stack, Text, Image, Flex, ButtonGroup, Button, useDisclosure } from "@chakra-ui/react";
import moment from "moment";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import OrderService from "services/orders/order-service";
import Layout from "scenes/layouts";
import Number from "components/number-format";
import OrderPayManualDialog from "./pay-manual";

const OrderDetailScene = (): ReactElement => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const [order, setOrder] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { isOpen: isShowPayManualDialog, onOpen: onShowPayManualDialog, onClose: onClosePayManualDialog } = useDisclosure();

    useEffect(() => {
        setIsLoading(true);
        OrderService.Get(orderId).then((res: any) => {
            setOrder(res.result);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleRefreshData = (order: any) => {
        setOrder(order);
        onClosePayManualDialog();
    }

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} my={2}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Order {order.invoiceNo} - {order.statusString}</Heading>
                </Box>
                <Box mt={6}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 5, lg: 8 }}>
                        <Stack direction={'row'} spacing={4} align={'center'} cursor={"pointer"} onClick={() => window.open(`/members/${order.user.id}`, "_blank")}>
                            <Avatar size={"lg"} src={order.user.profilePictureUrl || ''} />
                            <Stack direction={'column'} spacing={0} fontSize={'sm'}>
                                <Text fontWeight={600}>{order.user.fullName}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>{order.user.userName}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>{order.user.phoneNumber}</Text>
                            </Stack>
                        </Stack>
                        <Stack direction={'row'} spacing={4} align={'center'}>
                            <Stack direction={'column'} spacing={0} fontSize={'sm'}>
                                <Text fontWeight={600}>Invoice: {order.invoiceNo}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Status: {order.statusString}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Tanggal: {moment(order.creationTime).format("DD MMMM yyyy HH:mm")}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Utm Source: {order.utm.source}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Utm Medium: {order.utm.medium}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Utm Campaign: {order.utm.campaign}</Text>
                            </Stack>
                        </Stack>
                    </SimpleGrid>
                </Box>
                <Divider mt={4} />
                <Box mt={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 5, lg: 8 }}>
                        <Flex>
                            <Box>
                                <Image
                                    h={'120px'}
                                    src={order.program.posterUrl}
                                    alt={order.productName}
                                    objectFit='cover'
                                    rounded={'lg'}
                                />
                            </Box>
                            <Box ml={4}>
                                <Text>{order.program.fullName}</Text>
                                <Text fontSize={'xs'}>{order.program.author.name}</Text>

                                <Text fontWeight={'bold'}>
                                    {
                                        order.amount === 0 ?
                                            'GRATIS'
                                            :
                                            <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={order.amount} />
                                    }
                                </Text>
                            </Box>
                        </Flex>
                        <Box fontSize={'sm'}>
                            <Text>Voucher: <strong>{order.voucherCode || '-'}</strong></Text>
                            <Text>Subtotal: <strong>Rp {String.toFormatSeparator(order.subTotal)}</strong></Text>
                            <Text>Discount: <strong>Rp {String.toFormatSeparator(order.discount)}</strong></Text>
                            <Text>Total: <strong>Rp {String.toFormatSeparator(order.amount)}</strong></Text>
                            <Text>Total yang dibayar: <strong>Rp {String.toFormatSeparator(order.paidAmount)}</strong></Text>
                            {
                                order.outstanding > 0 &&
                                <Text>Sisa: <strong>{String.toFormatSeparator(order.outstanding)}</strong></Text>
                            }
                        </Box>
                    </SimpleGrid>
                </Box>
                <Divider mt={4} />

                {
                    order.paymentMethod === 10 &&
                    order.paymentManuals.map((paymentManual: any) => {
                        return (
                            <>
                                <Box mt={4} fontSize={'sm'}>
                                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 2, lg: 4 }}>
                                        <Text>Tanggal Pembayaran: <strong>{moment(paymentManual.paymentDate).format("DD MMMM yyyy HH:mm")}</strong></Text>
                                        {/*<Text>Bayar Dari: <strong>{paymentManual.bankName}</strong></Text>*/}
                                        {/*<Text>Nomor Rekening: <strong>{paymentManual.bankAccountNumber}</strong></Text>*/}
                                        <Text>Nama Pengirim: <strong>{paymentManual.bankAccountName}</strong></Text>
                                        <Text>Penerima: <strong>{`${paymentManual.logosBankAccount.bankName} - ${paymentManual.logosBankAccount.bankAccountNumber}`}</strong></Text>
                                        <Text>Total yang dibayar: <strong>Rp {String.toFormatSeparator(paymentManual.amount)}</strong></Text>
                                    </SimpleGrid>
                                    {
                                        paymentManual.isHaveScreenshot &&
                                        <Image height={'200px'} mt={2} src={paymentManual.receiptUrl} />
                                    }
                                </Box>
                                <Divider mt={4} />
                            </>
                        );
                    })
                }

                <Box mt={4}>
                    <ButtonGroup>
                        <Button variant={'outline'} onClick={() => { navigate(-1); }}>Kembali</Button>
                        {
                            (order.status === 10 || order.status === 20 || order.status === 40) &&
                            <Button onClick={onShowPayManualDialog}>Bayar</Button>
                        }
                    </ButtonGroup>
                </Box>
            </Container>
            {
                isShowPayManualDialog &&
                <OrderPayManualDialog
                    order={order}
                    onClose={onClosePayManualDialog}
                    onRefreshData={handleRefreshData}
                />
            }
        </Layout >
    );
};

export default OrderDetailScene;